
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSimplifiedBeaconMinorLateralRed as ObiSimplifiedBeaconMinorLateralRedElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-simplified-beacon-minor-lateral-red.js';
 
 
 

 
 export const ObiSimplifiedBeaconMinorLateralRed = createComponent({
   react: React,
   tagName: 'obi-simplified-beacon-minor-lateral-red',
   elementClass: ObiSimplifiedBeaconMinorLateralRedElement,
   events: {
     
   }
  });
 
 